import PaymentCalculatorProvider from 'payment-calculator-v25/PaymentCalculatorProvider.jsx';
import PaymentCalculator from 'payment-calculator-v25/components/PaymentCalculator/PaymentCalculator.jsx';

import en from 'payment-calculator-v25/i18n/en.json';
import fr from 'payment-calculator-v25/i18n/fr.json';

const translations = { en, fr };
const root = PaymentCalculator;
const provider = PaymentCalculatorProvider;
const main = PaymentCalculator;

export const widgets = {
    PaymentCalculator: {
        components: {
            root,
            provider,
            main,
        },
        translations,
    },
};

export default {
    root,
    provider,
    PaymentCalculatorProvider: provider,
    PaymentCalculator: main,
    translations,
};
